// extracted by mini-css-extract-plugin
export default {"scrollArea":"gzbFDHYqhpbG0q0JG1HZ","canScrollUp":"lJoRw9ZOSY8wICwbH0BA","canScrollDown":"vuSRindGs8BXs7bikBXM","content":"pOESJwtttnfsE5nIuRi1","collapsed":"VVkhTnSSSKVsvbiOCdWe"};